/** Piezas comunes de las páginas: estados de carga, título de la pestaña y nombres de los usuarios. */
import { useMemo, type ReactNode } from "react";
import type { CorreoDe } from "@/features/auditoria";
import { useUsuarios } from "@/features/usuarios";
import { t } from "@/shared/i18n";
import { useTituloPagina } from "@/shared/lib/titulo";
import { Cargando, ErrorDeCarga } from "@/shared/ui";

export function SegunConsulta({
  consulta,
  children,
}: {
  readonly consulta: { readonly isPending: boolean; readonly isError: boolean; readonly refetch: () => unknown };
  readonly children: () => ReactNode;
}) {
  if (consulta.isPending) return <Cargando texto={t.general.cargando} />;
  if (consulta.isError) {
    return (
      <ErrorDeCarga
        titulo={t.general.errorTitulo}
        texto={t.general.errorTexto}
        textoReintentar={t.general.reintentar}
        alReintentar={() => void consulta.refetch()}
      />
    );
  }
  return children();
}

export function useTitulo(pagina: string) {
  useTituloPagina(t.marca.titulo(pagina));
}

/** La auditoría guarda el id del usuario; para leerla se muestra su correo. */
export function useCorreoDe(): CorreoDe {
  const { data } = useUsuarios();
  return useMemo(() => {
    const porId = new Map((data ?? []).map((x) => [x.usuario.usuarioId, x.usuario.correo]));
    return (id: string) => porId.get(id);
  }, [data]);
}
